<template>
    <section>
        <o-pagination :current="2" :total="100" :per-page="10" />
    </section>
</template>
